import { render, staticRenderFns } from "./Widget2.vue?vue&type=template&id=3d6b63ef&"
import script from "./Widget2.vue?vue&type=script&lang=js&"
export * from "./Widget2.vue?vue&type=script&lang=js&"
import style0 from "./Widget2.vue?vue&type=style&index=0&id=3d6b63ef&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports